import React from "react";
import Step from "./Step";
import formElements from "./formElements";

const getFormField = (
  field,
  shop,
  { handleAttachmentAdded, handleAttachmentRemoved, attachments, attachmentError, imageMessage },
) => {
  if (field === "ORDER_NUMBER_CR_NUMBER_OPTIONAL") {
    return shop ? formElements.CR_NUMBER_OPTIONAL : formElements.ORDER_NUMBER;
  }
  if (field === "IMAGE_UPLOAD") {
    return formElements.IMAGE_UPLOAD(
      handleAttachmentAdded,
      handleAttachmentRemoved,
      attachments,
      attachmentError,
      imageMessage,
    );
  }
  return formElements[field];
};

export const getEscalatedFormElements = (
  fields,
  shop,
  { handleAttachmentAdded, handleAttachmentRemoved, attachments, attachmentError, imageMessage },
) => {
  const imageUploadIndex = fields.findIndex(it => it === "IMAGE_UPLOAD");
  const elements = fields.map(field =>
    getFormField(field, shop, {
      handleAttachmentAdded,
      handleAttachmentRemoved,
      attachments,
      attachmentError,
      imageMessage,
    }),
  );

  elements.splice(0, 0, {
    component: () => <Step index={2} title="Provide your CASE number" />,
  });
  if (imageUploadIndex > 0) {
    elements.splice(2, 0, {
      component: () => <Step index={3} title="Provide your details" />,
    });
    elements.splice(imageUploadIndex + 2, 0, {
      component: () => <Step index={4} title="Add supporting photos" optional />,
    });
    elements.splice(imageUploadIndex + 4, 0, {
      component: () => <Step index={5} title="Add your message" />,
    });
  }
  return elements;
};

export const getEmailFormElements = (
  fields,
  shop,
  { handleAttachmentAdded, handleAttachmentRemoved, attachments, attachmentError, imageMessage },
) => {
  const impageUploadIndex = fields.findIndex(it => it === "IMAGE_UPLOAD");
  const elements = fields.map(field =>
    getFormField(field, shop, {
      handleAttachmentAdded,
      handleAttachmentRemoved,
      attachments,
      attachmentError,
      imageMessage,
    }),
  );
  if (impageUploadIndex > 0) {
    elements.splice(0, 0, {
      component: () => <Step index={1} title="Provide your details" />,
    });
    elements.splice(impageUploadIndex + 1, 0, {
      component: () => <Step index={2} title="Add supporting photos" optional />,
    });
    elements.splice(impageUploadIndex + 3, 0, {
      component: () => <Step index={3} title="Add your message" />,
    });
  }
  return elements;
};

const getUrlNodes = queryParam => {
  const urlNodes = queryParam?.split("-") || [];
  return urlNodes || [];
};

export const isOnlineShoppingEnabled = urlParam => {
  return getUrlNodes(urlParam).findIndex(n => n === "online") > -1;
};
